const productList = document.querySelector('.product-list');

if (productList) {
  const axiosGetProductList = async (inputsGroupedByName) => {
    const productListElem = productList.querySelector('.product-list__row');
    const noResultElem = productList.querySelector('.product-list__not-found');

    const formDataInput = {
      action: 'getFilteredProductList',
      nonce: await getNonceForAction('getFilteredProductList'),
      ...inputsGroupedByName,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      productListElem.innerHTML = '';
      if (productListElem && data.data.html_list) {
        productListElem.innerHTML = data.data.html_list;
        noResultElem.classList.add('hide');
      }
      if (noResultElem && !data.data.html_list) {
        noResultElem.classList.remove('hide');
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['material', 'start', 'end', 'alignment', 'sort', 'eco_subsidy']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => {
          // Replace spaces with hyphens (-)
          const sanitizedKey = item.replace(/[^a-zA-Z0-9_-]/g, '-').toLowerCase();
          const sanitizedValue = formDataInput[item]
            .replace(/[^a-zA-Z0-9\s_|-]/g, '-')
            .toLowerCase()
            .replace(/\s+/g, '-');
          return `${sanitizedKey}=${sanitizedValue}`;
        })
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
      productList.scrollIntoView();
    } catch (err) {
      console.error(err);
    }
  };

  // Inputs grouped by `data-fv-name`
  const getInputsGroupedByName = () => {
    const allInputs = productList.querySelectorAll('.product-filter__body input');

    const groupedByFvName = Array.from(allInputs).reduce((acc, input) => {
      const name = input.getAttribute('data-fv-name');
      if (!acc[name]) {
        acc[name] = [];
      }
      if (input.checked) {
        acc[name].push(input.value);
      } else if (input.type === 'text') {
        acc[name] = [input.value];
      }
      return acc;
    }, {});

    // Format each array as a string with pipe delimiter
    const formattedArray = {};
    for (const [key, values] of Object.entries(groupedByFvName)) {
      formattedArray[key] = values.length > 0 ? values.join('|') : '';
    }

    return formattedArray;
  };

  // All input's change event
  const allFilterInputs = productList.querySelectorAll('.product-filter__body input');
  allFilterInputs.forEach((input) => {
    const parent = input.closest('.range-slider__inputs');

    if (parent) {
      input.addEventListener('input', () => {
        axiosGetProductList(getInputsGroupedByName());
      });
    } else {
      input.addEventListener('change', () => {
        axiosGetProductList(getInputsGroupedByName());
      });
    }
  });
}
